import {Injectable, Injector} from '@angular/core';
import {
    HttpInterceptor,
    HttpRequest,
    HttpHandler,
    HttpSentEvent,
    HttpHeaderResponse,
    HttpProgressEvent,
    HttpResponse,
    HttpUserEvent,
    HttpErrorResponse
} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/finally';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/take';

import {AuthService} from './auth.service';


@Injectable()
export class HttpInterceptorService implements HttpInterceptor {

    constructor(private injector: Injector) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpSentEvent |
        HttpHeaderResponse | HttpProgressEvent | HttpResponse<any> | HttpUserEvent<any>> {
        return next.handle(req)
            .catch(
                error => {
                    if (error instanceof HttpErrorResponse) {
                        switch ((<HttpErrorResponse>error).status) {
                            case 401:
                            case 403:
                                if (!req.url.match('login_check')) {
                                    this.redirectToLogin();
                                }
                        }
                    } else {
                        return Observable.throw(error);
                    }
                }
            )
    }

    redirectToLogin() {
        const auth = this.injector.get(AuthService);
        return auth.destroy();
    }
}



// WEBPACK FOOTER //
// /var/www/backend/src/app/core/service/http-interceptor.service.ts